import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col,
    Card
} from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link"
import AnchorLink from 'react-anchor-link-smooth-scroll'
import React, {
    useRef,
    useEffect,
    useState
} from "react";

export default function FeaturedEmployersImageWithText({
    global,
    pathPrefix,
    customClass = "",
    buttonTitle,
    buttonLink,
    post,
    page,
    secondary_post,
    pageButtonLink,
    pageButtonTitle
}) {
    useEffect(() => {
        // Add offset to anchor links within post.Content
        const contentContainer = document.getElementById(`post-contents`);
        if (contentContainer) {
            const anchorLinks = contentContainer.querySelectorAll('a[href^="#"]');
            anchorLinks.forEach(anchor => {
                anchor.addEventListener('click', (e) => {
                    e.preventDefault();
                    const targetId = anchor.getAttribute('href').substring(1);
                    const targetElement = document.getElementById(targetId);
                    if (targetElement) {
                        const offset = 120; // Set your desired offset value
                        const targetOffset = targetElement.offsetTop - offset;
                        window.scrollTo({
                            top: targetOffset,
                            behavior: 'smooth',
                        });
                    }
                });
            });
        }
    }, [post?.content]);


    return (
        post?.length >= 1 && (
            <section className={`${styles.root} ${customClass} ${secondary_post?.length >= 2 ? "with-border" : ""}`}>
                {page?.title == "KPMG" ?
                    <>
                        {pageButtonLink && pageButtonTitle && (
                            <>
                                <Container>
                                    <div className="mb-5 back-links">
                                        <Link href={pageButtonLink}>
                                            <a className="text-nowrap arrow-left d-inline-flex align-items-center"><strong>{pageButtonTitle}</strong></a>
                                        </Link>
                                    </div>
                                </Container>
                            </>
                        )}
                        {post?.map((post, index) => (
                            <div className={`${index >= 1 ? "kpmg-template position-relative" : ""}`}>
                                <div className={`${index == 0 ? "py-5" : ""} bg-light position-relative`}>
                                    {index >= 1 ?
                                        <SourceFlowImage
                                            src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                            size="2000x"
                                            alt={`${post?.id}`}
                                            className="position-absolute"
                                        />
                                        : ""}
                                    <Container className="position-relative py-5">
                                        <Row key={index} className={`mainWrapper align-items-center mb-5 ${secondary_post?.length >= 2 ? " pb-5" : ""}`} id={`section-${index}`}>
                                            {index >= 1 ?
                                                <>
                                                    <Col md={6}>
                                                        <div className="post-content mb-4">
                                                            {post?.content ?
                                                                <div id="post-contents" dangerouslySetInnerHTML={{ __html: post?.content }} />
                                                                : ""}
                                                            {post?.buttonanchorsection ?
                                                                <AnchorLink offset='80' href={`#${post?.buttonlink}`} className="primaryBtn no-arrow banner-anchor mt-4" aria-label="Scroll Bottom">
                                                                    {post?.button_title}
                                                                </AnchorLink>
                                                                :
                                                                <>
                                                                    {post?.buttonlink && post?.buttontitle && (
                                                                        post?.buttonnewtabpage ?
                                                                            <Link href={`${post?.buttonlink}`}>
                                                                                <a className="primaryBtn no-arrow mt-4" target="_blank" rel="noreferrer noopener">
                                                                                    {post?.buttontitle}
                                                                                </a>
                                                                            </Link> :
                                                                            <Link href={`${post?.buttonlink}`}>
                                                                                <a className="primaryBtn no-arrow mt-4">
                                                                                    {post?.buttontitle}
                                                                                </a>
                                                                            </Link>
                                                                    )}
                                                                </>}
                                                        </div>

                                                    </Col>
                                                </> :
                                                <>
                                                    <Col md={6}>
                                                        <div className="post-content mb-4">
                                                            {post?.content ?
                                                                <div id="post-contents" dangerouslySetInnerHTML={{ __html: post?.content }} />
                                                                : ""}
                                                            {post?.buttonanchorsection ?
                                                                <AnchorLink offset='80' href={`#${post?.buttonlink}`} className="primaryBtn no-arrow banner-anchor mt-4" aria-label="Scroll Bottom">
                                                                    {post?.button_title}
                                                                </AnchorLink>
                                                                :
                                                                <>
                                                                    {post?.buttonlink && post?.buttontitle && (
                                                                        post?.buttonnewtabpage ?
                                                                            <Link href={`${post?.buttonlink}`}>
                                                                                <a className="primaryBtn no-arrow mt-4" target="_blank" rel="noreferrer noopener">
                                                                                    {post?.buttontitle}
                                                                                </a>
                                                                            </Link> :
                                                                            <Link href={`${post?.buttonlink}`}>
                                                                                <a className="primaryBtn no-arrow mt-4">
                                                                                    {post?.buttontitle}
                                                                                </a>
                                                                            </Link>
                                                                    )}
                                                                </>}
                                                        </div>

                                                    </Col>
                                                    <Col md={6}>
                                                        <SourceFlowImage
                                                            src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                                            size="1000x"
                                                            alt={`${post?.id}`}
                                                            className="card-img"
                                                        />
                                                    </Col>
                                                </>}

                                        </Row>
                                    </Container>
                                </div>
                                {index == 0 && (
                                    <>
                                        {page?.image_with_text_sub_content ?
                                            <Container>
                                                <div className="sub-contents my-5" dangerouslySetInnerHTML={{ __html: page?.image_with_text_sub_content }} />
                                            </Container> : ""}
                                    </>
                                )}

                                {secondary_post?.length >= 2 && (
                                    <div className={`bg-white position-relative  ${index >= 1 ? "pt-5" : ""}`}>
                                        <Col md={12} className={`roles ${index >= 1 ? "py-5" : ""}`}>
                                            <div className="d-flex flex-wrap justify-content-center">
                                                {secondary_post?.map((post, secondary_index) => (
                                                    index == `${post?.templateid}` ?
                                                        <Card key={secondary_index} className="border-0 text-center bg-transparent px-4 mb-4">
                                                            <Link href={`${post?.link}`}>
                                                                <a target="_blank" rel="noreferrer noopener">
                                                                    <div>
                                                                        <SourceFlowImage
                                                                            src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                                                            size="1000x1000"
                                                                            alt={`${post?.title}`}
                                                                            className="card-img mb-4 p-0"
                                                                        />
                                                                    </div>
                                                                    <strong>{post.title}</strong>
                                                                </a>
                                                            </Link>
                                                        </Card>
                                                        : null
                                                ))}
                                            </div>
                                        </Col>
                                    </div>
                                )}

                            </div>
                        ))}
                    </> :

                    <Container>
                        {pageButtonLink && pageButtonTitle && (
                            <>
                                <div className="mb-5 back-links">
                                    <Link href={pageButtonLink}>
                                        <a className="text-nowrap arrow-left d-inline-flex align-items-center"><strong>{pageButtonTitle}</strong></a>
                                    </Link>
                                </div>
                            </>
                        )}
                        {post?.map((post, index) => (
                            <Row key={index} className={`mainWrapper align-items-center mb-5 ${secondary_post?.length >= 2 ? " pb-5" : ""}`} id={`section-${index}`}>
                                <Col md={6}>
                                    <div className="post-content mb-4">
                                        {post?.content ?
                                            <div id="post-contents" dangerouslySetInnerHTML={{ __html: post?.content }} />
                                            : ""}
                                        {post?.buttonanchorsection ?
                                            <AnchorLink offset='80' href={`#${post?.buttonlink}`} className="primaryBtn no-arrow banner-anchor mt-4" aria-label="Scroll Bottom">
                                                {post?.buttontitle}
                                            </AnchorLink>
                                            :
                                            <>
                                                {post?.buttonlink && post?.buttontitle && (
                                                    post?.buttonnewtabpage ?
                                                        <Link href={`${post?.buttonlink}`}>
                                                            <a className="primaryBtn no-arrow mt-4" target="_blank" rel="noreferrer noopener">
                                                                {post?.buttontitle}
                                                            </a>
                                                        </Link> :
                                                        <Link href={`${post?.buttonlink}`}>
                                                            <a className="primaryBtn no-arrow mt-4">
                                                                {post?.buttontitle}
                                                            </a>
                                                        </Link>
                                                )}
                                            </>}
                                    </div>
                                    {/* {post?.ButtonLink && post?.ButtonTitle && (
                                    <div>
                                        <Link href={`${post?.ButtonLink}`}>
                                            <a className="primaryBtn no-arrow">
                                                {post?.ButtonTitle}
                                            </a>
                                        </Link>
                                    </div>)} */}
                                </Col>
                                <Col md={6}>
                                    <SourceFlowImage
                                        src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                        size="1000x"
                                        alt={`${post?.id}`}
                                        className="card-img"
                                    />
                                </Col>
                                {page?.title == "KPMG" && index == 0 ?
                                    page?.image_with_text_sub_content ?
                                        <Container>
                                            <div className="sub-contents mt-5" dangerouslySetInnerHTML={{ __html: page?.image_with_text_sub_content }} />
                                        </Container>
                                        : "" : ""}

                                {index >= 1 && (
                                    <>
                                        {secondary_post?.length >= 2 && (
                                            <Col md={12} className="roles pt-5">
                                                <div className="d-flex flex-wrap justify-content-center">
                                                    {secondary_post?.map((post, secondary_index) => (
                                                        index == `${post?.templateid}` ?
                                                            <Card key={secondary_index} className="border-0 text-center bg-transparent px-4 mb-4">
                                                                <Link href={`${post?.link}`}>
                                                                    <a target="_blank" rel="noreferrer noopener">
                                                                        <div>
                                                                            <SourceFlowImage
                                                                                src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                                                                size="1000x1000"
                                                                                alt={`${post?.title}`}
                                                                                className="card-img mb-4 p-0"
                                                                            />
                                                                        </div>
                                                                        <strong>{post.title}</strong>
                                                                    </a>
                                                                </Link>
                                                            </Card>
                                                            : null
                                                    ))}
                                                </div>
                                            </Col>
                                        )}
                                    </>
                                )}
                            </Row>
                        ))}
                    </Container>}

            </section>
        )
    )
}